import React from "react";

type Form = any;

type Props = {
  form: Form;
  isSaving: boolean;
  handleSave: () => void;
};

export function QuickActions({ form, isSaving, handleSave }: Props): JSX.Element {
  const missing: string[] = [];
  if (!form.orderNumber?.trim()) missing.push("Ordernummer");
  if (!form.customer?.trim()) missing.push("Kund");
  if (!form.serial?.trim()) missing.push("Serienummer");
  if (!form.manufacturer?.trim()) missing.push("Tillverkare");
  if (!form.model?.trim()) missing.push("Modell");
  if (!form.productType?.trim()) missing.push("Produkttyp");
  if (!form.articleNumber?.trim()) missing.push("Artikelnummer hos Convit");
  if (!form.adapterYesNo?.trim()) missing.push("Adapter");
  if (!form.warrantyStartDate?.trim()) missing.push("Garantistart");

  const disabled =
    isSaving ||
    !form.orderNumber?.trim() ||
    !form.customer?.trim() ||
    !form.serial?.trim() ||
    !form.manufacturer?.trim() ||
    !form.model?.trim() ||
    !form.productType?.trim() ||
    !form.articleNumber?.trim() ||
    !form.adapterYesNo?.trim() ||
    !form.warrantyStartDate?.trim();

  const title =
    !form.orderNumber?.trim() ? "Fyll i ordernummer" :
      !form.customer?.trim() ? "Välj kund" :
        !form.serial?.trim() ? "Fyll i serienummer" :
          !form.manufacturer?.trim() ? "Välj tillverkare" :
            !form.model?.trim() ? "Välj modell" :
              !form.productType?.trim() ? "Välj produkttyp" :
                !form.articleNumber?.trim() ? "Fyll i artikelnummer" :
                  !form.adapterYesNo?.trim() ? "Välj adapterstatus" :
                    !form.warrantyStartDate?.trim() ? "Fyll i garantistart" :
                      "Spara enhet";

  return (
    <div className="gw-actions mt-2 flex items-center justify-between gap-2 flex-wrap">
      <div className="flex-1 min-w-0">
        {missing.length > 0 && (
          <div
            className="gw-banner gw-banner--warn m-0"
            role="status"
            aria-live="polite"
          >
            Saknas: {missing.join(", ")}
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={handleSave}
        className="gw-btn gw-btn-primary"
        disabled={disabled}
        title={title}
      >
        {isSaving ? "Sparar…" : "Spara enhet"}
      </button>
    </div>
  );
}
